exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text_wrap {\n  white-space: pre-line; }\n\n.btn {\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/global-help-dialog/global-help-dialog.component.scss
// module id = ../../../../../src/app/components/dialog/global-help-dialog/global-help-dialog.component.scss
// module chunks = main